export default __webpack_public_path__ + "static/media/32_mobile.30b61b69.jpg";